import {FC} from 'react'
import {MultiSelect, Option} from 'react-multi-select-component'
import '../../../../../../../style/multiSelectSucess.css'

type Props = {
  label: string
  placeholder: string
  options: Option[]
  value: string[]
  onChange: (value: string[]) => void
}

const MultiSelectFilter: FC<Props> = ({label, placeholder, options, value, onChange}) => {
  // Categorias e origens chegam com id numérico; os filtros trabalham com string.
  const normalized = options.map((option) => ({...option, value: String(option.value)}))

  return (
    <div className='mb-5'>
      <label className='form-label fs-6 fw-bold'>{label}:</label>
      <MultiSelect
        className='form-control rmscStyle'
        options={normalized}
        value={normalized.filter((option) => value.includes(option.value))}
        onChange={(selected: Option[]) => onChange(selected.map((option) => option.value))}
        labelledBy={label}
        overrideStrings={{
          selectSomeItems: placeholder,
          search: 'Procurar',
          selectAll: 'Selecionar todos',
          allItemsAreSelected: 'Todos selecionados',
        }}
      />
    </div>
  )
}

export {MultiSelectFilter}
